export const SET_USUARIO = "SET_USUARIO";
export const SET_CARRITO = "SET_CARRITO";
export const RESTART_CARRITO = "RESTART_CARRITO";
export const ALERT_SHOW = "ALERT_SHOW";


